export const generateNotificationUrl = (entityType, projectId, entityId, type, otherData) => {
    switch (entityType) {
      case 'TestCase':
        return `/project/${projectId}/testcases/${entityId}?type=${type}`;
      case 'PluginTestCycle':
        return `/project/${projectId}/testcycles/${entityId}?type=${type}`;
      case 'Execution':
        return `/project/${projectId}/testexecution/${entityId}?testcycle=${otherData?.testCycleKey}&association=${otherData?.testCaseKey}`;
      default:
        return '#'; 
    }
  };
  

export const getTimeElapsed = (created_at) => {
    const created = new Date(created_at);
    const currentTime = new Date();
    const timeDiff = Math.abs(currentTime - created);
    const minutes = Math.floor(timeDiff / 60000);
    const hours = Math.floor(minutes / 60);
    const days = Math.floor(hours / 24);

    if (days > 0) {
      return `${days} day${days > 1 ? 's' : ''} ago`;
    } else if (hours > 0) {
      return `${hours} hour${hours > 1 ? 's' : ''} ago`;
    } else if (minutes > 0) {
      return `${minutes} minute${minutes > 1 ? 's' : ''} ago`;
    } else {
      return 'Just now';
    }
  };